import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Chip, Typography } from "@mui/material";
import * as constants from "../../constants";
import { Row, Col } from "react-bootstrap";
import { Paper, Avatar } from "@mui/material";
import GroupCreateModal from "../../Group/GroupCreateModal";
import style from "./GroupModal.module.css";
import Link from "next/link";

const BASE_URL = constants.BASE_URL;

export default function GroupModal({
  open,
  handleClose,
  localStoreId,
  userID,
}) {
  const [fullWidth] = React.useState(true);
  const [maxWidth] = React.useState("sm");
  const [myGroups, setMyGroups] = React.useState([]);
  const [noGroup, setNoGroup] = React.useState([]);

  // group create
  const [openGroup, setOpenGroup] = React.useState(false);

  const handleGroupClose = () => {
    setOpenGroup(false);
  };

  const handleOwnGroup = () => {
    fetch(`${BASE_URL}/group/${localStorage.getItem("id")}/my-groups`, {
      method: "GET",
      headers: {
        Authorization: `Token ${localStorage.getItem("auth_token")}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.message) {
          setNoGroup([{ data: data.message }]);
        } else {
          setMyGroups(data);
        }
      });
  };

  // getting my-groups data
  React.useEffect(() => {
    handleOwnGroup();
  }, [userID, localStoreId]);

  return (
    <React.Fragment>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle className="text-center bg-warning">
          <Typography
            className="p-0 m-0"
            align="center"
            variant="h6"
            gutterBottom
          >
            Choose your Group
          </Typography>
          <Typography className="p-0 m-0" variant="caption" gutterBottom>
            Choose the group by which you want to open the course.
          </Typography>
        </DialogTitle>

        <DialogContent className="pt-3">
          <Row xs={1} sm={2} md={2} xl={3} className="g-2">
            {userID === localStoreId && (
              <Col className="my-2">
                <Paper
                  className={`${style.card} p-2 rounded-3 d-flex align-items-center justify-content-center`}
                  onClick={() => setOpenGroup(true)}
                >
                  <div
                    style={{ opacity: "0.5" }}
                    className="d-flex flex-column align-items-center"
                  >
                    <picture>
                      <img
                        src="https://img.icons8.com/pastel-glyph/64/000000/plus--v1.png"
                        alt="icon"
                      />
                    </picture>
                    <b>Create Group</b>
                  </div>
                </Paper>
              </Col>
            )}

            {myGroups.map((group, idx) => (
              <Col key={idx} className={`${style.box}`}>
                <Link href={`/course/create/${group.id}`}>
                  <Paper className={`${style.card} p-2 rounded-3 `}>
                    <div className="d-flex flex-column align-items-center">
                      <Avatar
                        sx={{
                          width: 75,
                          height: 75,
                          border: 1,
                          borderColor: "grey.500",
                        }}
                        alt="alt"
                        src={group.profile_pic}
                      />

                      <div className="text-center pt-2">
                        <b
                          className="d-inline-block text-truncate"
                          style={{ maxWidth: "150px" }}
                        >
                          {group.name}
                        </b>
                      </div>
                    </div>
                  </Paper>
                </Link>
              </Col>
            ))}
          </Row>
        </DialogContent>
        <DialogActions>
          <Chip onClick={handleClose} label="Cancel" color="error" />
        </DialogActions>
      </Dialog>

      {/* Create group modal */}
      <GroupCreateModal
        open={openGroup}
        handleClose={() => handleGroupClose()}
        handleOwnGroup={handleOwnGroup}
      />
    </React.Fragment>
  );
}
